import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import "@cloudscape-design/global-styles/index.css";

import { AuthProvider } from "./context/AuthContext";
import { MenuProvider } from "./context/MenuContext";
import { ChatSessionProvider } from "./context/ChatSessionContext";
import { NotificationProvider } from "./context/NotificationContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminProtectedRoute from "./components/auth/AdminProtectedRoute";

// Public pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import ChangePassword from "./pages/ChangePassword";

// Layout
import MainLayout from "./components/layout/MainLayout";

// Protected pages
import Home from "./pages/Home";

// Admin
import AdminInterface from "./components/admin/AdminInterface";

// Boxer pages
import DeliveryCommandCenter from "./pages/boxer/DeliveryCommandCenter";
import DeliveryMonitoring from "./pages/boxer/DeliveryMonitoring";
import ExecuteQuery from "./pages/boxer/ExecuteQuery";

import { I18nProvider } from "@cloudscape-design/components/i18n";
import messages from "@cloudscape-design/components/i18n/messages/all.en";

function App() {
  return (
    <I18nProvider messages={[messages]} locale="en">
      <AuthProvider>
        <NotificationProvider>
        <MenuProvider>
          <Router>
            <ChatSessionProvider>
            <Switch>
              {/* Public routes */}
              <Route exact path="/login" component={Login} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/change-password" component={ChangePassword} />

              {/* Admin routes — separate auth, no MainLayout */}
              <Route path="/admin/login" render={() => (
                <AdminProtectedRoute>
                  <AdminInterface />
                </AdminProtectedRoute>
              )} />
              <Route path="/admin" render={() => (
                <AdminProtectedRoute>
                  <AdminInterface />
                </AdminProtectedRoute>
              )} />

              {/* Protected user routes — wrapped in MainLayout */}
              <ProtectedRoute exact path="/" component={() => (<MainLayout><Home /></MainLayout>)} />

              {/* Boxer routes */}
              <ProtectedRoute path="/boxer/delivery-command-center" menuProtected
                component={() => (<MainLayout><DeliveryCommandCenter /></MainLayout>)} />
              <ProtectedRoute path="/boxer/delivery-monitoring" menuProtected
                component={() => (<MainLayout><DeliveryMonitoring /></MainLayout>)} />
              <ProtectedRoute path="/boxer/execute-query" menuProtected
                component={() => (<MainLayout><ExecuteQuery /></MainLayout>)} />

              <Redirect to="/" />
            </Switch>
            </ChatSessionProvider>
          </Router>
        </MenuProvider>
        </NotificationProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
